import { render, staticRenderFns } from "./modal-import-order.vue?vue&type=template&id=bc65efb0&"
import script from "./modal-import-order.vue?vue&type=script&lang=js&"
export * from "./modal-import-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports